import { ERROR_PAGE, MISSING_PAGE, OFFLINE_PAGE } from '@app/constants/routes';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

const IsOffline = () => {
  const { asPath } = useRouter();
  const isNotOffLinePage = asPath !== OFFLINE_PAGE;
  const topPositionPages = [ERROR_PAGE, MISSING_PAGE];

  const positionClassName = topPositionPages.includes(asPath) ? 'top-0' : 'bottom-0';

  const isOffline = useMemo(() => !navigator.onLine, [navigator.onLine]);

  return isOffline && isNotOffLinePage && (
    <div className={`bg-orange-400 text-white
    fixed flex justify-center w-full py-1 text-xs ${positionClassName}`}
    >
      Offline Mode
    </div>
  );
};

export default IsOffline;
